export const LoginUser = (data) => {
  return {
    type: "LOGIN",
    payload: data
  };
}

export const LogoutUser = () => {
  return {
    type: "LOGOUT"
  }
}

export const UpdateUser = (data) => {
  return {
    type: "UPDATE",
    payload: data
  }
}
